(() => {
  const root = document.getElementById('mr-art-framework');
  if (!root) return;
  const labels = JSON.parse(document.getElementById('mr-framework-labels').textContent);
  const storageKey = 'mitch_framework_learning_v1';
  let storageAvailable = true;
  let progress = {};
  let lastLesson = '';
  try {
    const saved = JSON.parse(localStorage.getItem(storageKey) || '{}');
    progress = saved.completed && typeof saved.completed === 'object' ? saved.completed : {};
    lastLesson = typeof saved.lastLesson === 'string' ? saved.lastLesson : '';
  } catch (_) {
    storageAvailable = false;
  }
  const format = (template, done, total) => template.replace('__DONE__', done).replace('__TOTAL__', total);
  const save = () => {
    try {
      localStorage.setItem(storageKey, JSON.stringify({ completed: progress, lastLesson }));
    } catch (_) {
      storageAvailable = false;
    }
    const note = root.querySelector('.mr-progress-note');
    if (note) note.textContent = storageAvailable ? labels.saved_device : labels.session_only;
  };
  const refreshProgress = () => {
    const inputs = Array.from(root.querySelectorAll('[data-complete]'));
    inputs.forEach(input => {
      input.checked = progress[input.dataset.complete] === true;
      input.closest('[data-lesson]').querySelector('.mr-lesson-status').textContent = input.checked ? labels.completed : '';
    });
    root.querySelectorAll('.mr-pillar').forEach(pillar => {
      const current = Array.from(pillar.querySelectorAll('[data-complete]'));
      pillar.querySelector('.mr-pillar-progress').textContent = format(labels.pillar_progress, current.filter(input => input.checked).length, current.length);
    });
    const total = root.querySelector('.mr-total-progress');
    if (total) total.textContent = format(labels.progress, inputs.filter(input => input.checked).length, inputs.length);
    const resume = root.querySelector('.mr-resume');
    if (resume) resume.hidden = !lastLesson || !root.querySelector('[data-lesson="' + CSS.escape(lastLesson) + '"]');
  };
  const openLesson = id => {
    if (!isUnlocked()) return;
    const lesson = root.querySelector('[data-lesson="' + CSS.escape(id) + '"]');
    if (!lesson) return;
    const pillar = lesson.closest('.mr-pillar');
    if (pillar) pillar.open = true;
    lesson.open = true;
    lesson.scrollIntoView({ block: 'start', behavior: 'smooth' });
    lesson.querySelector('summary').focus({ preventScroll: true });
  };
  const makeButton = (label, handler) => {
    const button = document.createElement('button');
    button.type = 'button';
    button.textContent = label;
    button.addEventListener('click', handler);
    return button;
  };
  const initialiseMembers = () => {
    if (!isUnlocked() || root.classList.contains('mr-members')) return;
    root.classList.add('mr-members');
    const intro = root.querySelector('#pillars-intro');
    const updateParagraph = intro.querySelector('p');
    if (updateParagraph) {
      const updateBlock = updateParagraph.parentElement;
      const updateDetail = document.createElement('details');
      updateDetail.className = 'mr-updates';
      const updateSummary = document.createElement('summary');
      updateParagraph.style.cssText = '';
      updateSummary.append(updateParagraph);
      updateDetail.append(updateSummary);
      updateBlock.replaceWith(updateDetail);
      updateBlock.style.cssText = '';
      updateDetail.append(updateBlock);
    }
    const grid = root.querySelector('.pillars-grid');
    const toolbar = document.createElement('div');
    toolbar.className = 'mr-learning-toolbar';
    const title = document.createElement('h2');
    title.textContent = labels.overview;
    const counts = document.createElement('span');
    counts.className = 'mr-total-progress';
    counts.setAttribute('aria-live', 'polite');
    toolbar.append(title, counts);
    const actions = document.createElement('div');
    actions.className = 'mr-learning-actions';
    const resume = makeButton(labels.resume, () => openLesson(lastLesson));
    resume.className = 'mr-resume';
    actions.append(resume);
    const savedNote = document.createElement('span');
    savedNote.className = 'mr-progress-note';
    savedNote.textContent = storageAvailable ? labels.saved_device : labels.session_only;
    actions.append(savedNote);
    grid.before(toolbar, actions);
    Array.from(grid.querySelectorAll('.pillar-card')).forEach(card => {
      const id = ['a', 'b', 'c', 'd'].find(value => card.classList.contains(value));
      const overlay = root.querySelector('#overlay-' + id);
      const pillar = document.createElement('details');
      pillar.className = 'mr-pillar mr-pillar-' + id;
      pillar.id = 'mr-pillar-' + id;
      const summary = document.createElement('summary');
      summary.className = 'mr-pillar-summary';
      const letter = card.querySelector('.pillar-bg-letter');
      const titleGroup = document.createElement('div');
      titleGroup.className = 'mr-pillar-heading';
      titleGroup.append(card.querySelector('.pillar-tag'), card.querySelector('.pillar-name'));
      const count = document.createElement('span');
      count.className = 'mr-pillar-progress';
      titleGroup.append(count);
      const plus = document.createElement('span');
      plus.className = 'mr-disclosure-icon';
      plus.setAttribute('aria-hidden', 'true');
      plus.textContent = '+';
      summary.append(letter, titleGroup, plus);
      const body = document.createElement('div');
      body.className = 'mr-pillar-body';
      const overview = document.createElement('div');
      overview.className = 'mr-pillar-overview';
      while (card.firstChild) overview.append(card.firstChild);
      body.append(overview);
      const oldLink = overview.querySelector('.pillar-link');
      if (oldLink) {
        const openButton = makeButton(oldLink.textContent.trim(), () => {
          overlay.querySelector('.mr-lesson').open = true;
          overlay.querySelector('.mr-lesson').scrollIntoView({ block: 'start', behavior: 'smooth' });
        });
        openButton.className = 'mr-pillar-open';
        oldLink.replaceWith(openButton);
      }
      overlay.classList.add('mr-inline-pillar');
      const controls = document.createElement('div');
      controls.className = 'mr-lesson-controls';
      controls.append(makeButton(labels.expand_all, () => overlay.querySelectorAll('.mr-lesson').forEach(lesson => { lesson.open = true; })));
      controls.append(makeButton(labels.collapse_all, () => overlay.querySelectorAll('.mr-lesson').forEach(lesson => { lesson.open = false; })));
      body.append(controls, overlay);
      pillar.append(summary, body);
      card.replaceWith(pillar);
    });
    const outcomes = root.querySelector('#section-outcomes');
    const outcomesDetail = document.createElement('details');
    outcomesDetail.className = 'mr-outcomes';
    const outcomesSummary = document.createElement('summary');
    outcomesSummary.textContent = labels.outcomes;
    outcomes.replaceWith(outcomesDetail);
    outcomesDetail.append(outcomesSummary, outcomes);
    refreshProgress();
  };
  root.querySelectorAll('[data-complete]').forEach(input => {
    input.addEventListener('change', () => {
      if (!isUnlocked()) return;
      progress[input.dataset.complete] = input.checked;
      lastLesson = input.dataset.complete;
      save();
      refreshProgress();
    });
  });
  root.querySelectorAll('[data-lesson]').forEach(lesson => {
    lesson.addEventListener('toggle', () => {
      if (!lesson.open || !isUnlocked()) return;
      lastLesson = lesson.dataset.lesson;
      save();
      refreshProgress();
    });
  });
  const originalUnlockedView = window.showUnlockedView;
  window.showUnlockedView = function () {
    if (!root.classList.contains('mr-members')) originalUnlockedView();
    initialiseMembers();
  };
  window.openOverlay = function (id) {
    if (!isUnlocked()) { showPasswordGate(id); return; }
    showUnlockedView();
    const pillar = root.querySelector('#mr-pillar-' + id);
    if (!pillar) return;
    pillar.open = true;
    pillar.scrollIntoView({ block: 'start', behavior: 'smooth' });
    pillar.querySelector('summary').focus({ preventScroll: true });
  };
  window.closeOverlay = function () {
    root.querySelectorAll('.mr-pillar[open]').forEach(pillar => { pillar.open = false; });
    document.body.style.overflow = '';
    const page = root.querySelector('#page-content');
    if (page) page.style.visibility = 'visible';
    root.querySelector('#pillars').scrollIntoView({ block: 'start', behavior: 'smooth' });
  };
  root.querySelectorAll('iframe').forEach(frame => {
    frame.title = frame.closest('#overlay-a') ? 'Mitch talks through Pillar A' : 'Introduction to the Full-Time Artist Framework';
    frame.loading = 'lazy';
  });
  const gate = root.querySelector('#password-gate');
  gate.setAttribute('role', 'dialog');
  gate.setAttribute('aria-modal', 'true');
  const gateTitle = gate.querySelector('.gate-title');
  gateTitle.id = 'mr-gate-title';
  gate.setAttribute('aria-labelledby', gateTitle.id);
  root.querySelector('#gate-input').setAttribute('aria-label', gateTitle.textContent.trim());
  root.querySelector('#gate-error').setAttribute('role', 'alert');
  if (document.readyState !== 'loading' && isUnlocked()) showUnlockedView();
})();
